module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.roi) ? _c('div', {
    staticClass: "component-tabbed-vehicle-costs"
  }, [_c('div', {
    staticClass: "action-bar"
  }, [_vm._m(0), _c('div', {
    staticClass: "action"
  }, [_c('modal-reveal', {
    ref: "modalAddCost",
    attrs: {
      "sizing": "small"
    }
  }, [_c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-2x"
  })]), _c('h2', [_vm._v("Add cost")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns small-6"
  }, [_c('label', [_vm._v("Cost Type"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cost.asset_cost_record_type_id),
      expression: "cost.asset_cost_record_type_id"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.cost, "asset_cost_record_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.costTypes), function(costType) {
    return _c('option', {
      domProps: {
        "value": costType.id
      }
    }, [_vm._v(_vm._s(costType.name))])
  }), 0)]), _c('label', [_vm._v("Amount"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cost.amount),
      expression: "cost.amount"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.cost.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cost, "amount", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Date"), _c('date-picker', {
    model: {
      value: (_vm.cost.date),
      callback: function($$v) {
        _vm.$set(_vm.cost, "date", $$v)
      },
      expression: "cost.date"
    }
  })], 1)]), _c('div', {
    staticClass: "columns small-6"
  }, [_c('label', [_vm._v("Description"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cost.description),
      expression: "cost.description"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cost.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cost, "description", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Vat %"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vatRate),
      expression: "vatRate"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vatRate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vatRate = $event.target.value
      }
    }
  })])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.cost.asset_cost_record_type_id || !_vm.cost.amount || !_vm.cost.description
    },
    on: {
      "click": _vm.addCost
    }
  }, [_vm._v("Save")])])])])], 1)]), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabs-inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns text-center"
  }, [_c('Label', [_vm._v("Select range")]), _c('RangePicker', {
    attrs: {
      "start-date": _vm.search.start,
      "end-date": _vm.search.end
    },
    on: {
      "input": _vm.setDates
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns small-6 text-center"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('span', [_vm._v("Reservations")]), _c('h3', [_vm._v(_vm._s(_vm.currency) + _vm._s(Math.ceil(_vm.roi.reservation_amount)))])])])]), _c('div', {
    staticClass: "columns small-6 text-center"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('span', [_vm._v("Costs")]), _c('h3', [_vm._v(_vm._s(_vm.currency) + _vm._s(Math.ceil(_vm.roi.costs_amount)))])])])])])])]), _c('base-list', {
    ref: "list",
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "search": _vm.search,
      "showPerPageSelect": false
    }
  }, [_c('header-columns', {
    attrs: {
      "slot": "before",
      "columns": _vm.headers
    },
    slot: "before"
  })], 1)], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("Vehicle Costs")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5df25e76!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/VehicleCosts.vue
// module id = 2377
// module chunks = 1